export const themeColors = {
  darkGray: '#212a31',
  mediumGray: '#2e3944',
  blueIsh: '#0970af',
  weirdGreen: '#738c91',
  lightGreen: '#d3d9d4',
};
